import React from 'react';

const Work = () => {
    return (
        <div className="work">
            <div className="container">
                <h1 className="l-title">How does it work?</h1>

                <div className="row big-work-box-row big-work-box-row-left">
                    <div className="col-md-6 big-work-box">
                        <div className="row">
                            <div className="work-box">
                                <div className="wor-box-item">
                                    <div>
                                        <img src="/img/w1.png" alt="w1"/>
                                    </div>
                                    <div>
                                        <h4>Registration</h4>
                                        <p>Send all information which is required and
                                            special board will be opened for you</p>
                                    </div>
                                </div>
                                <div className="wor-box-item-line">
                                    <div className="line-mid">

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6"></div>
                        </div>
                    </div>
                    <div className="col-md-6"></div>
                </div>
                <div className="row  big-work-box-row  big-work-box-row-right">
                    <div className="col-md-6"></div>
                    <div className="col-md-6 big-work-box">
                        <div className="row">

                            <div className="work-box">
                                <div className="wor-box-item-line">
                                    <div className="line-mid">

                                    </div>
                                </div>
                                <div className="wor-box-item">
                                    <div>
                                        <img src="/img/w2.png" alt="w2"/>
                                    </div>
                                    <div>
                                        <h4>Connecting cameras</h4>
                                        <p>Connecting current cameras by entering IP adresses to platform</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6"></div>
                        </div>
                    </div>
                </div>
                <div className="row big-work-box-row  big-work-box-row-left">
                    <div className="col-md-6 big-work-box">
                        <div className="row">
                            <div className="work-box">
                                <div className="wor-box-item">
                                    <div>
                                        <img src="/img/w3.png" alt="w3"/>
                                    </div>
                                    <div>
                                        <h4>Deploying models</h4>
                                        <p>Choose our services and deploy them your current cameras by clicking only one button</p>
                                    </div>
                                </div>
                                <div className="wor-box-item-line">
                                    <div className="line-mid">

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6"></div>
                        </div>
                    </div>
                    <div className="col-md-6"></div>
                </div>
                <div className="row  big-work-box-row  big-work-box-row-right">
                    <div className="col-md-6"></div>
                    <div className="col-md-6 big-work-box">
                        <div className="row">

                            <div className="work-box">
                                <div className="wor-box-item-line">
                                    <div className="line-mid">

                                    </div>
                                </div>
                                <div className="wor-box-item">
                                    <div>
                                        <img src="/img/w4.png" alt="w4"/>
                                    </div>
                                    <div>
                                        <h4>Observation</h4>
                                        <p>Observe useful analytics get informations and enjoy from service ... </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Work;